import React, { useState, useEffect, useCallback } from 'react'
import { Dispatcher, RootState } from 'AppTypes'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { getVideoGoLiverById } from '@services/api/videoApi'
import { corporateSiteUrl } from '@environments/environment'
import * as actions from '../state_management/actions'
import VideoPopup from '../popup/VideoPopup'
import ListPremiumVideo from './ListPremiumVideo'
import ListVideoGoLiver from './ListVideoGoLiver'
import ListVideoGoLiverOrder2 from './ListVideoGoLiverOrder2'
import ListVideoByFoodCateGroup from './ListVideoByFoodCateGroup'
import ListRecentlyPostedVideo from './ListRecentlyPostedVideo'
import ListNewIntroductionVideo from './ListNewIntroductionVideo'

const mapStateToProps = (state: RootState) => ({
  isLoading: state.topPage.isLoading,
  foodCategoryGroups: state.topPage.foodCategoryGroups
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  setIsLoading: (isLoading: boolean) => dispatch(actions.setLoading(isLoading))
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
const TopPageBody: React.FC<Props> = ({
  foodCategoryGroups
}) => {
  const [showVideoPopup, setShowVideoPopup] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState()
  const location = useLocation()
  const history = useHistory()

  const onSelectVideo = useCallback((video: any) => {
    setSelectedVideo(video)
    setShowVideoPopup(true)
    if (video.videoType === 1) {
      history.push(`/?video=${video.id}`)
    }
  }, [history])

  const onSelectVideoById = useCallback(async (videoId: string) => {
    try {
      const res = await getVideoGoLiverById(videoId)
      if (res && res.data) {
        onSelectVideo({ ...res.data, url: res.data.videoUrl })
      }
    } catch (error) {
      console.error(error)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCloseVideoPopup = () => {
    setShowVideoPopup(false)
    history.push('/')
  }
  const votePageLink = 'http://onelink.to/evv4z5'

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const videoId = params.get('video')
    if (videoId) {
      onSelectVideoById(videoId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {selectedVideo
        && (
          <VideoPopup
            video={selectedVideo}
            showModal={showVideoPopup}
            onCloseModal={onCloseVideoPopup}
          />
        )}
      <ListRecentlyPostedVideo onSelectVideo={onSelectVideo} />
      <ListNewIntroductionVideo onSelectVideo={onSelectVideo} />
      <ListPremiumVideo onSelectVideo={onSelectVideo} />

      {/* <ListCartoon /> */}

      {/* <ListVideoTopPage onSelectVideo={onSelectVideo} /> */}

      <ListVideoGoLiverOrder2 id="category-1" onSelectVideo={onSelectVideo} />

      {/* <ListVideoSeenRecently videos={listVideoSeenRecently} onSelectVideo={onSelectVideo} /> */}
      {/* <ListVideoHistory onSelectVideo={onSelectVideo} /> */}

      <ListVideoGoLiver id="category-2" onSelectVideo={onSelectVideo} />

      <div className="card card-orange mt-4">
        <div className="card-header text-center">
          応援したい店舗を推薦しよう！ご推薦者様全員に100ポイント進呈
        </div>
        <div className="card-body">
          <p className="card-text">
            あなたの応援したい店舗がまだゲマトスに未加入の場合はぜひご推薦ください。ご推薦いただいた店舗がゲマトスにページを開設した場合、
            ご推薦者全員に100ポイントを進呈いたします。推薦はゲマトスアプリから受け付けておりますので、ダウンロードしてご利用ください。
          </p>
          <a href={votePageLink} target="_blank" rel="noreferrer" className="btn">
            アプリダウンロードはこちら
          </a>
        </div>
      </div>

      {foodCategoryGroups.map((item: any) => (
        <ListVideoByFoodCateGroup
          key={item.id}
          category={item}
          onSelectVideo={onSelectVideo}
        />
      ))}

      <div className="card card-red mt-4">
        <div className="card-header text-center">
          店舗オーナー・運営者様へ GMTSに加入しませんか？
        </div>
        <div className="card-body">
          <p className="card-text">
            GMTSに加入しませんか？あなたのお店を動画で応援したいお客様がたくさんいらっしゃいます。
            <br />
            無料でお店の公式ページを制作いたしますので、ぜひご加入ください。
          </p>
          <a href={`${corporateSiteUrl}/touroku/`} className="btn btn-primary">
            無料でGMTSに加入
          </a>
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <a href={corporateSiteUrl}>
          <i className="bi bi-question-circle-fill" /> GMTSとは？
        </a>
      </div>
    </>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopPageBody)
